var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageDotsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10001 12H8.11001M12.6 12H12.61M17.1 12H17.11M12.6 21C17.5706 21 21.6 16.9706 21.6 12C21.6 7.02944 17.5706 3 12.6 3C7.62945 3 3.60001 7.02944 3.60001 12C3.60001 13.1971 3.83375 14.3397 4.25808 15.3845C4.33929 15.5845 4.37989 15.6845 4.39801 15.7653C4.41573 15.8443 4.42221 15.9028 4.42222 15.9839C4.42223 16.0667 4.40719 16.1569 4.37712 16.3374L3.78414 19.8952C3.72204 20.2678 3.691 20.4541 3.74877 20.5888C3.79934 20.7067 3.8933 20.8007 4.0112 20.8512C4.14591 20.909 4.3322 20.878 4.70477 20.8159L8.26266 20.2229C8.4431 20.1928 8.53332 20.1778 8.61615 20.1778C8.69717 20.1778 8.75567 20.1843 8.83473 20.202C8.91556 20.2201 9.01554 20.2607 9.2155 20.3419C10.2603 20.7663 11.4029 21 12.6 21ZM8.60001 12C8.60001 12.2761 8.37616 12.5 8.10001 12.5C7.82387 12.5 7.60001 12.2761 7.60001 12C7.60001 11.7239 7.82387 11.5 8.10001 11.5C8.37616 11.5 8.60001 11.7239 8.60001 12ZM13.1 12C13.1 12.2761 12.8762 12.5 12.6 12.5C12.3239 12.5 12.1 12.2761 12.1 12C12.1 11.7239 12.3239 11.5 12.6 11.5C12.8762 11.5 13.1 11.7239 13.1 12ZM17.6 12C17.6 12.2761 17.3762 12.5 17.1 12.5C16.8239 12.5 16.6 12.2761 16.6 12C16.6 11.7239 16.8239 11.5 17.1 11.5C17.3762 11.5 17.6 11.7239 17.6 12Z",
    stroke: "#4C60E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageDotsCircle);
export default __webpack_public_path__ + "static/media/message-dots-circle.7af20412b126186aa21367bf0965da00.svg";
export { ForwardRef as ReactComponent };